<ng-container *ngFor="let alert of notifications">
    <ng-container [ngSwitch]="alert.type">
        <div
            [ngClass]="{
                'info-popup-v2 info-popup-v2--information-v2': isInfo(alert),
                'info-popup': isError(alert) || isSuccess(alert),
                'info-popup--error': isError(alert),
                'info-popup--success': isSuccess(alert)
            }"
            role="alert"
            aria-live="assertive">
            <div class="info-popup-v2__type" *ngSwitchCase="AlertType.Info">
                <span class="info-popup-v2__icon icon icon-circle-warning"></span>
            </div>

            <div class="info-popup__type" *ngSwitchCase="AlertType.Success">
                <ng-container *ngIf="env?.USE_TAILWIND">
                    <img
                        class="info-popup__icon icon icon-success dark:filter-yellow"
                        src="{{ assetsPath }}/icon_notification_success.svg"
                        alt="" />
                </ng-container>

                <ng-container *ngIf="!env?.USE_TAILWIND">
                    <img
                        class="info-popup__icon icon icon-success hide-for-wcag"
                        src="{{ assetsPath }}/icon_notification_success.png"
                        alt="" />
                    <img
                        class="info-popup__icon icon icon-success show-high-contrast-view"
                        src="{{ assetsPath }}/icon_notification_success-wcag.png"
                        alt="" />
                </ng-container>
            </div>

            <div class="info-popup__type" *ngSwitchCase="AlertType.Error">
                <ng-container *ngIf="env?.USE_TAILWIND">
                    <img
                        class="info-popup__icon icon icon-error vl-app-light:h-12 sr-app-light:h-12 dark:filter-yellow"
                        src="{{ assetsPath }}/icon_notification_error.svg"
                        alt="" />
                </ng-container>

                <ng-container *ngIf="!env?.USE_TAILWIND">
                    <img
                        class="info-popup__icon icon icon-error hide-for-wcag"
                        src="{{ assetsPath }}/icon_notification_error.png"
                        alt="" />
                    <img
                        class="info-popup__icon icon icon-error show-high-contrast-view"
                        src="{{ assetsPath }}/icon_notification_error-wcag.png"
                        alt="" />
                </ng-container>
            </div>

            <div [ngClass]="isInfo(alert) ? 'info-popup-v2__title' : 'info-popup__title'">{{ alert.title }}</div>
            <div class="info-popup-v2__text" [innerHTML]="alert.message"></div>
        </div>
    </ng-container>
</ng-container>
